import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../services/api';

const STATUS_VEICULO = {
  disponivel: { txt: 'Disponivel',  cor: '#1e7d47', bg: 'rgba(30,125,71,.1)' },
  reservado:  { txt: 'Reservado',   cor: '#b07d10', bg: 'rgba(176,125,16,.1)' },
  vendido:    { txt: 'Vendido',     cor: '#555',    bg: '#f0f0f0' },
  inativo:    { txt: 'Inativo',     cor: '#999',    bg: '#f5f5f5' },
};

const STATUS_SOL = {
  aguardando:        { txt: 'Aguardando analise', cor: '#b07d10', bg: 'rgba(216,189,105,.18)' },
  aprovado:          { txt: 'Aprovado',           cor: '#1e7d47', bg: 'rgba(30,125,71,.1)'   },
  reprovado:         { txt: 'Reprovado',          cor: '#c33',    bg: 'rgba(200,50,50,.08)'  },
  ajuste_solicitado: { txt: 'Ajuste solicitado',  cor: '#c85718', bg: 'rgba(200,87,24,.08)'  },
  recusado:          { txt: 'Recusado',           cor: '#c33',    bg: 'rgba(200,50,50,.08)'  },
  em_analise:        { txt: 'Em análise',         cor: '#555',    bg: '#f0f0f0'              },
};

const MARCAS = ['Chevrolet','Volkswagen','Ford','Fiat','Toyota','Honda','Dodge','Jeep','Willys','Alfa Romeo','Mercedes-Benz','BMW','Porsche','Jaguar','Triumph','MG','DKW','Simca','Outra'];
const UFS    = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

function ModalEdicaoSolicitacao({ solicitacao, onClose, onSalvo }) {
  const dadosIniciais = typeof solicitacao.dados_veiculo === 'string'
    ? JSON.parse(solicitacao.dados_veiculo || '{}')
    : (solicitacao.dados_veiculo || {});

  const [form, setForm] = useState({
    marca: '', modelo: '', versao: '', ano: '', preco: '', quilometragem: '',
    cambio: '', combustivel: '', cor: '', motor: '', cidade: '', estado: '',
    placa: '', chassi: '', descricao: '', estado_conservacao: 'bom',
    quitado: false, documentacao_em_dia: false, possui_debitos: false,
    possui_restricoes: false, aceita_negociacao: false, aceita_troca: false,
    original: false, placa_preta: false, restaurado: false, pecas_originais: false,
    historico_manutencao: false, detalhes_pintura: '', detalhes_funilaria: '',
    detalhes_mecanica: '', observacoes: '',
    ...dadosIniciais,
  });
  const [novasFotos, setNovasFotos] = useState({});
  const [salvando, setSalvando]     = useState(false);
  const [erro, setErro]             = useState('');

  const upd = e => {
    const v = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm(f => ({ ...f, [e.target.name]: v }));
  };
  const updF = e => setNovasFotos(f => ({ ...f, [e.target.name]: e.target.files }));

  const salvar = async e => {
    e.preventDefault(); setSalvando(true); setErro('');
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      Object.entries(novasFotos).forEach(([campo, files]) =>
        Array.from(files).forEach(f => fd.append(campo, f))
      );
      await api.put(`/solicitacoes/${solicitacao.id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      onSalvo();
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar.');
    } finally { setSalvando(false); }
  };

  const Secao = ({ titulo, children }) => (
    <div style={{ marginBottom:24 }}>
      <div style={{ fontSize:10, letterSpacing:1.6, textTransform:'uppercase', color:'var(--rust)', fontWeight:900, marginBottom:14, paddingBottom:8, borderBottom:'1px solid var(--border)' }}>{titulo}</div>
      {children}
    </div>
  );
  const Campo = ({ label, children }) => (
    <div className="form-group" style={{ marginBottom:14 }}>
      <label style={{ fontSize:12, fontWeight:700 }}>{label}</label>
      {children}
    </div>
  );
  const Check = ({ name, label }) => (
    <label style={{ display:'flex', alignItems:'center', gap:10, fontSize:14, cursor:'pointer', marginBottom:10 }}>
      <input type="checkbox" name={name} checked={!!form[name]} onChange={upd} style={{ accentColor:'var(--rust)', width:16, height:16 }} />
      {label}
    </label>
  );

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.6)', display:'flex', alignItems:'flex-start', justifyContent:'center', zIndex:1000, padding:'20px', overflowY:'auto' }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background:'#fff', borderRadius:12, padding:'32px 36px', width:'100%', maxWidth:680, margin:'auto' }}>
        <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:22, marginBottom:6 }}>Editar e reenviar anúncio</h2>
        <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:24 }}>Corrija as informações solicitadas e reenvie para análise.</p>
        {erro && <div className="alert alert-danger" style={{ marginBottom:16 }}>{erro}</div>}
        <form onSubmit={salvar}>

          <Secao titulo="Dados do veículo">
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              <Campo label="Marca">
                <select name="marca" value={form.marca} onChange={upd}>
                  <option value="">Selecione</option>
                  {MARCAS.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
              </Campo>
              <Campo label="Modelo"><input name="modelo" value={form.modelo} onChange={upd} /></Campo>
              <Campo label="Versão / Série"><input name="versao" value={form.versao} onChange={upd} /></Campo>
              <Campo label="Ano"><input name="ano" value={form.ano} onChange={upd} type="number" min="1900" max="2010" /></Campo>
              <Campo label="Preço (R$)"><input name="preco" value={form.preco} onChange={upd} type="number" /></Campo>
              <Campo label="Quilometragem"><input name="quilometragem" value={form.quilometragem} onChange={upd} type="number" /></Campo>
              <Campo label="Câmbio">
                <select name="cambio" value={form.cambio} onChange={upd}>
                  <option value="">Selecione</option>
                  <option value="manual">Manual</option>
                  <option value="automatico">Automático</option>
                </select>
              </Campo>
              <Campo label="Combustível"><input name="combustivel" value={form.combustivel} onChange={upd} /></Campo>
              <Campo label="Cor"><input name="cor" value={form.cor} onChange={upd} /></Campo>
              <Campo label="Motor"><input name="motor" value={form.motor} onChange={upd} /></Campo>
              <Campo label="Placa"><input name="placa" value={form.placa} onChange={upd} /></Campo>
              <Campo label="Chassi"><input name="chassi" value={form.chassi} onChange={upd} /></Campo>
            </div>
            <Campo label="Estado de conservação">
              <select name="estado_conservacao" value={form.estado_conservacao} onChange={upd}>
                <option value="excelente">Excelente</option>
                <option value="bom">Bom</option>
                <option value="regular">Regular</option>
                <option value="restauro">Em restauro</option>
              </select>
            </Campo>
          </Secao>

          <Secao titulo="Características">
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:0 }}>
              <Check name="quitado"            label="Quitado" />
              <Check name="documentacao_em_dia" label="Documentação em dia" />
              <Check name="original"            label="Original" />
              <Check name="restaurado"          label="Restaurado" />
              <Check name="placa_preta"         label="Placa preta" />
              <Check name="pecas_originais"     label="Peças originais" />
              <Check name="historico_manutencao" label="Histórico de manutenção" />
              <Check name="aceita_negociacao"   label="Aceita negociação" />
              <Check name="aceita_troca"        label="Aceita troca" />
              <Check name="possui_debitos"      label="Possui débitos" />
              <Check name="possui_restricoes"   label="Possui restrições" />
            </div>
          </Secao>

          <Secao titulo="Descrição e detalhes">
            <Campo label="Descrição geral">
              <textarea name="descricao" value={form.descricao} onChange={upd} rows={4} />
            </Campo>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              <Campo label="Detalhes da pintura"><textarea name="detalhes_pintura" value={form.detalhes_pintura} onChange={upd} rows={2} /></Campo>
              <Campo label="Detalhes da funilaria"><textarea name="detalhes_funilaria" value={form.detalhes_funilaria} onChange={upd} rows={2} /></Campo>
              <Campo label="Detalhes mecânicos"><textarea name="detalhes_mecanica" value={form.detalhes_mecanica} onChange={upd} rows={2} /></Campo>
              <Campo label="Observações adicionais"><textarea name="observacoes" value={form.observacoes} onChange={upd} rows={2} /></Campo>
            </div>
          </Secao>

          <Secao titulo="Localização">
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              <Campo label="Cidade"><input name="cidade" value={form.cidade} onChange={upd} /></Campo>
              <Campo label="Estado">
                <select name="estado" value={form.estado} onChange={upd}>
                  <option value="">UF</option>
                  {UFS.map(u => <option key={u} value={u}>{u}</option>)}
                </select>
              </Campo>
            </div>
          </Secao>

          <Secao titulo="Adicionar/substituir fotos (opcional)">
            <p style={{ fontSize:12, color:'var(--ink-muted)', marginBottom:14, lineHeight:1.6 }}>
              As fotos existentes serão mantidas. Envie novas para adicionar ou substituir.
            </p>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              {[['foto_frente','Frente'],['foto_traseira','Traseira'],['foto_lateral','Lateral'],['foto_interior','Interior'],['foto_painel','Painel'],['foto_motor','Motor'],['fotos_outras','Detalhes adicionais']].map(([name, label]) => (
                <Campo key={name} label={label}>
                  <input type="file" name={name} accept="image/*" multiple={name==='fotos_outras'} onChange={updF} style={{ fontSize:12 }} />
                </Campo>
              ))}
            </div>
          </Secao>

          <div style={{ display:'flex', gap:12, paddingTop:8 }}>
            <button type="submit" className="btn btn-primary" disabled={salvando}>
              {salvando ? 'Enviando…' : 'Salvar e reenviar para análise'}
            </button>
            <button type="button" className="btn btn-outline" onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Badge({ txt, cor, bg }) {
  return (
    <span style={{
      display:'inline-block', fontSize:11, fontWeight:700, letterSpacing:.8,
      padding:'3px 10px', borderRadius:20, color: cor, background: bg,
      border: `1px solid ${cor}33`,
    }}>{txt}</span>
  );
}

function ModalEdicao({ veiculo, onClose, onSalvo }) {
  const [form, setForm] = useState({
    preco:             veiculo.preco             || '',
    quilometragem:     veiculo.quilometragem     || '',
    descricao:         veiculo.descricao         || '',
    whatsapp_vendedor: veiculo.whatsapp_vendedor || '',
    aceita_negociacao: !!veiculo.aceita_negociacao,
    aceita_troca:      !!veiculo.aceita_troca,
  });
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro]         = useState('');

  const upd = e => {
    const v = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm(f => ({ ...f, [e.target.name]: v }));
  };

  const salvar = async e => {
    e.preventDefault(); setSalvando(true); setErro('');
    try {
      await api.patch(`/veiculos/meus/${veiculo.id}`, form);
      onSalvo();
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar.');
    } finally { setSalvando(false); }
  };

  return (
    <div
      style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:20 }}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div style={{ background:'#fff', borderRadius:12, padding:'32px 36px', width:'100%', maxWidth:520, maxHeight:'90vh', overflowY:'auto' }}>
        <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:22, marginBottom:24 }}>Editar anúncio</h2>
        {erro && <div className="alert alert-danger" style={{ marginBottom:16 }}>{erro}</div>}
        <form onSubmit={salvar}>
          <div className="form-group">
            <label>Preco (R$)</label>
            <input name="preco" type="number" value={form.preco} onChange={upd} />
          </div>
          <div className="form-group">
            <label>Quilometragem</label>
            <input name="quilometragem" type="number" value={form.quilometragem} onChange={upd} />
          </div>
          <div className="form-group">
            <label>WhatsApp de contato</label>
            <input name="whatsapp_vendedor" value={form.whatsapp_vendedor} onChange={upd} onInput={e => { e.target.value = e.target.value.replace(/\D/g, ''); }} inputMode="numeric" placeholder="Ex: 31999990000" />
          </div>
          <div className="form-group">
            <label>Descricao</label>
            <textarea name="descricao" value={form.descricao} onChange={upd} rows={4} />
          </div>
          <div style={{ display:'flex', gap:20, marginBottom:20 }}>
            <label className="checkbox-group">
              <input type="checkbox" name="aceita_negociacao" checked={form.aceita_negociacao} onChange={upd} />
              <span style={{ fontSize:14 }}>Aceita negociacao</span>
            </label>
            <label className="checkbox-group">
              <input type="checkbox" name="aceita_troca" checked={form.aceita_troca} onChange={upd} />
              <span style={{ fontSize:14 }}>Aceita troca</span>
            </label>
          </div>
          <p style={{ fontSize:12, color:'var(--ink-muted)', marginBottom:20, lineHeight:1.55 }}>
            Alterações de marca, modelo, ano e fotos devem ser solicitadas pelo suporte Heritage.
          </p>
          <div style={{ display:'flex', gap:12 }}>
            <button type="submit" className="btn btn-primary btn-sm" disabled={salvando}>
              {salvando ? 'Salvando...' : 'Salvar alterações'}
            </button>
            <button type="button" className="btn btn-outline btn-sm" onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

const MOTIVOS_ENCERRAMENTO = [
  { value: 'desisti', label: 'Desisti de vender o veículo' },
  { value: 'outro_meio', label: 'Vendi por outro meio (fora da plataforma)' },
  { value: 'plataforma', label: 'Vendi por meio da plataforma Web Heritage' },
  { value: 'outro', label: 'Outro motivo' },
];

function ModalEncerramento({ veiculo, onConfirmar, onCancelar }) {
  const [motivo, setMotivo] = useState('');
  const vendeuplataforma = motivo === 'plataforma';

  return (
    <div
      style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1100, padding:20 }}
      onClick={e => e.target === e.currentTarget && onCancelar()}
    >
      <div style={{ background:'#fff', borderRadius:12, padding:'32px 36px', width:'100%', maxWidth:500 }}>
        <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:22, marginBottom:8 }}>Encerrar anúncio</h2>
        <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:24, lineHeight:1.6 }}>
          <strong style={{ color:'var(--ink)' }}>{veiculo.marca} {veiculo.modelo} {veiculo.ano}</strong> — por que você está encerrando este anúncio?
        </p>

        <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:24 }}>
          {MOTIVOS_ENCERRAMENTO.map(m => (
            <label key={m.value} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 16px', border:`1px solid ${motivo === m.value ? 'var(--rust)' : 'var(--border)'}`, borderRadius:'var(--r-sm)', cursor:'pointer', background: motivo === m.value ? 'rgba(154,86,55,.05)' : '#fff', transition:'.15s' }}>
              <input type="radio" name="motivo" value={m.value} checked={motivo === m.value} onChange={() => setMotivo(m.value)} style={{ accentColor:'var(--rust)', width:16, height:16, flexShrink:0 }} />
              <span style={{ fontSize:14 }}>{m.label}</span>
            </label>
          ))}
        </div>

        {vendeuplataforma && (
          <div style={{ background:'rgba(255,240,220,.7)', border:'1px solid rgba(154,86,55,.35)', borderLeft:'3px solid var(--rust)', borderRadius:'0 var(--r-sm) var(--r-sm) 0', padding:'14px 18px', marginBottom:20, fontSize:13, color:'var(--ink-mid)', lineHeight:1.65 }}>
            <strong style={{ display:'block', color:'var(--rust)', marginBottom:6, fontSize:11, letterSpacing:1, textTransform:'uppercase' }}>Taxa de manutenção da plataforma</strong>
            Ao confirmar que a venda ocorreu por meio da plataforma Web Heritage, será aplicada uma <strong>taxa de manutenção de R$ 300,00</strong>, conforme previsto nos Termos de Uso. Nossa equipe entrará em contato para os detalhes do pagamento.
          </div>
        )}

        <div style={{ display:'flex', gap:12, justifyContent:'flex-end' }}>
          <button className="btn btn-outline btn-sm" onClick={onCancelar}>Cancelar</button>
          <button
            className="btn btn-sm"
            style={{ background: vendeuplataforma ? 'var(--rust)' : '#be2e2e', color:'#fff', opacity: motivo ? 1 : 0.4 }}
            disabled={!motivo}
            onClick={() => onConfirmar(motivo)}
          >
            {vendeuplataforma ? 'Confirmar venda (taxa R$ 300)' : 'Confirmar encerramento'}
          </button>
        </div>
      </div>
    </div>
  );
}

function CardVeiculo({ v, onEditar, onEncerrar, excluindo }) {
  const st = STATUS_VEICULO[v.status] || { txt: v.status, cor:'#555', bg:'#eee' };
  return (
    <div style={{ background:'#fff', border:'1px solid var(--border)', borderRadius:12, overflow:'hidden', display:'flex', marginBottom:14 }}>
      {v.foto_principal
        ? <img src={v.foto_principal} alt={v.modelo} style={{ width:150, flexShrink:0, objectFit:'cover' }} />
        : <div style={{ width:150, flexShrink:0, background:'#f0ede8', display:'flex', alignItems:'center', justifyContent:'center', color:'#ccc', fontSize:32 }}>&#9651;</div>
      }
      <div style={{ padding:'18px 22px', flex:1, display:'flex', flexDirection:'column', gap:6 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12 }}>
          <div style={{ fontFamily:"'Playfair Display',serif", fontSize:17, fontWeight:600 }}>
            {v.marca} {v.modelo} {v.versao}
          </div>
          <Badge txt={st.txt} cor={st.cor} bg={st.bg} />
        </div>
        <div style={{ fontSize:13, color:'var(--ink-muted)' }}>{v.ano}</div>
        <div style={{ fontSize:16, fontWeight:700, color:'var(--rust)' }}>
          {v.preco ? `R$ ${Number(v.preco).toLocaleString('pt-BR')}` : 'Preço a consultar'}
        </div>
        <div style={{ fontSize:12, color:'var(--ink-muted)' }}>
          Publicado em {new Date(v.created_at).toLocaleDateString('pt-BR')}
        </div>
        <div style={{ display:'flex', gap:10, marginTop:6 }}>
          <button className="btn btn-outline btn-sm" onClick={() => onEditar(v)}>Editar informações</button>
          <button
            style={{ background:'none', border:'1px solid #e44', color:'#c33', borderRadius:6, padding:'6px 14px', fontSize:12, cursor:'pointer' }}
            onClick={() => onEncerrar(v)}
            disabled={excluindo === v.id}
          >
            {excluindo === v.id ? 'Encerrando...' : 'Encerrar anúncio'}
          </button>
        </div>
      </div>
    </div>
  );
}

function CardSolicitacao({ s, onEditar }) {
  const st = STATUS_SOL[s.status] || { txt: s.status, cor:'#555', bg:'#eee' };
  const marca  = s.marca  ? s.marca.replace(/"/g,'')  : '—';
  const modelo = s.modelo ? s.modelo.replace(/"/g,'') : '—';
  const ano    = s.ano    ? s.ano.replace(/"/g,'')    : '—';
  const precisaAjuste = s.status === 'ajuste_solicitado';
  const borda = precisaAjuste ? '2px solid #c85718' : '1px solid var(--border)';
  return (
    <div style={{ background:'#fff', border: borda, borderRadius:12, padding:'18px 22px', marginBottom:14 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
        <div style={{ fontFamily:"'Playfair Display',serif", fontSize:17, fontWeight:600 }}>
          {marca} {modelo} {ano !== '—' ? `(${ano})` : ''}
        </div>
        <Badge txt={st.txt} cor={st.cor} bg={st.bg} />
      </div>

      {precisaAjuste && s.mensagem_ajuste && (
        <div style={{ background:'rgba(200,87,24,.07)', border:'1px solid rgba(200,87,24,.25)', borderRadius:8, padding:'14px 16px', margin:'12px 0' }}>
          <div style={{ fontSize:10, letterSpacing:1.2, textTransform:'uppercase', color:'#c85718', fontWeight:900, marginBottom:8 }}>
            ⚠ Ajuste solicitado pela equipe Heritage
          </div>
          <div style={{ fontSize:13, color:'var(--ink)', lineHeight:1.7, whiteSpace:'pre-wrap' }}>{s.mensagem_ajuste}</div>
        </div>
      )}

      <div style={{ fontSize:12, color:'var(--ink-muted)', lineHeight:1.6 }}>
        {s.status === 'aguardando'        && 'Sua solicitação está em análise pela equipe Heritage. Você será notificado quando for publicada.'}
        {s.status === 'aprovado'          && 'Solicitação aprovada. O veículo foi publicado na plataforma.'}
        {s.status === 'reprovado'         && 'Solicitação não aprovada. Entre em contato com o suporte Heritage para mais detalhes.'}
        {s.status === 'recusado'          && 'Solicitação recusada. Entre em contato com o suporte Heritage para mais detalhes.'}
        {s.status === 'em_analise'        && 'Sua solicitação está sendo analisada pela equipe Heritage.'}
        {precisaAjuste && !s.mensagem_ajuste && 'A equipe Heritage solicitou ajustes no seu anúncio. Edite e reenvie.'}
      </div>

      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:12 }}>
        <div style={{ fontSize:11, color:'#bbb' }}>
          Enviado em {new Date(s.created_at).toLocaleDateString('pt-BR')}
        </div>
        {precisaAjuste && (
          <button className="btn btn-sm" onClick={() => onEditar(s)}
            style={{ background:'#c85718', color:'#fff', border:'none', fontWeight:900 }}>
            ✏ Editar e reenviar
          </button>
        )}
      </div>
    </div>
  );
}

export default function MeusAnuncios() {
  const [veiculos,      setVeiculos]      = useState([]);
  const [solicitacoes,  setSolicitacoes]  = useState([]);
  const [carregando,    setCarregando]    = useState(true);
  const [editando,             setEditando]             = useState(null);
  const [editandoSolicitacao,  setEditandoSolicitacao]  = useState(null);
  const [excluindo,            setExcluindo]            = useState(null);
  const [encerrando,           setEncerrando]           = useState(null);

  const carregar = async () => {
    setCarregando(true);
    try {
      const [resV, resS] = await Promise.allSettled([
        api.get('/veiculos/meus'),
        api.get('/solicitacoes/minhas'),
      ]);
      if (resV.status === 'fulfilled') setVeiculos(resV.value.data);
      if (resS.status === 'fulfilled') setSolicitacoes(resS.value.data);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => { carregar(); }, []);

  const confirmarEncerramento = async (motivo) => {
    const v = encerrando;
    setEncerrando(null);
    setExcluindo(v.id);
    try {
      await api.delete(`/veiculos/meus/${v.id}`);
      setVeiculos(prev => prev.filter(x => x.id !== v.id));
      if (motivo === 'plataforma') {
        alert('Anúncio encerrado. Nossa equipe entrará em contato para os detalhes da taxa de manutenção de R$ 300,00.');
      }
    } catch { alert('Erro ao encerrar anúncio.'); }
    finally { setExcluindo(null); }
  };

  // Solicitacoes aguardando ou reprovadas (aprovadas viram veiculos publicados)
  const solPendentes = solicitacoes.filter(s => s.status !== 'aprovado');

  const semNada = !carregando && veiculos.length === 0 && solPendentes.length === 0;

  return (
    <>
      <Navbar />
      {editando && (
        <ModalEdicao
          veiculo={editando}
          onClose={() => setEditando(null)}
          onSalvo={() => { setEditando(null); carregar(); }}
        />
      )}
      {editandoSolicitacao && (
        <ModalEdicaoSolicitacao
          solicitacao={editandoSolicitacao}
          onClose={() => setEditandoSolicitacao(null)}
          onSalvo={() => { setEditandoSolicitacao(null); carregar(); }}
        />
      )}
      {encerrando && (
        <ModalEncerramento
          veiculo={encerrando}
          onConfirmar={confirmarEncerramento}
          onCancelar={() => setEncerrando(null)}
        />
      )}
      <div style={{ background:'var(--cream)', minHeight:'calc(100vh - 112px)', padding:'56px 0' }}>
        <div className="container" style={{ maxWidth:800 }}>
          <div className="page-header">
            <div className="eyebrow">Plano Premium</div>
            <h1 className="section-title">Meus anúncios</h1>
            <div className="gold-rule" />
            <p style={{ color:'var(--ink-muted)', fontSize:14, lineHeight:1.7 }}>
              Acompanhe o status dos veículos que você enviou para análise e os que já estão publicados.
            </p>
          </div>

          <div style={{ marginBottom:24 }}>
            <Link to="/vender" className="btn btn-primary btn-sm">+ Enviar novo anúncio</Link>
          </div>

          {carregando && <p style={{ color:'var(--ink-muted)' }}>Carregando...</p>}

          {semNada && (
            <div className="card" style={{ padding:'40px 32px', textAlign:'center' }}>
              <p style={{ color:'var(--ink-muted)', fontSize:15, marginBottom:20 }}>
                Você ainda não enviou nenhum anúncio.
              </p>
              <Link to="/vender" className="btn btn-primary">Enviar meu primeiro anúncio</Link>
            </div>
          )}

          {/* Veiculos publicados */}
          {veiculos.length > 0 && (
            <div style={{ marginBottom:32 }}>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, marginBottom:16 }}>
                Anúncios publicados ({veiculos.length})
              </h2>
              {veiculos.map(v => (
                <CardVeiculo
                  key={v.id}
                  v={v}
                  onEditar={setEditando}
                  onEncerrar={setEncerrando}
                  excluindo={excluindo}
                />
              ))}
            </div>
          )}

          {/* Solicitacoes em andamento / reprovadas */}
          {solPendentes.length > 0 && (
            <div>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, marginBottom:16 }}>
                Solicitações ({solPendentes.length})
              </h2>
              {solPendentes.map(s => (
                <CardSolicitacao key={s.id} s={s} onEditar={setEditandoSolicitacao} />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
